import { render, staticRenderFns } from "./ControlBar.vue?vue&type=template&id=4676c7ca&scoped=true"
import script from "./ControlBar.vue?vue&type=script&lang=js"
export * from "./ControlBar.vue?vue&type=script&lang=js"
import style0 from "./ControlBar.vue?vue&type=style&index=0&id=4676c7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4676c7ca",
  null
  
)

export default component.exports